function RuleItem({ met, label }) {
  return (
    <div className="flex items-center gap-3">
      <span
        className={`material-symbols-outlined text-[18px] transition-colors ${
          met ? 'text-primary' : 'text-outline-variant'
        }`}
      >
        {met ? 'check_circle' : 'radio_button_unchecked'}
      </span>
      <span className={`text-xs transition-colors ${met ? 'text-on-surface font-medium' : 'text-secondary'}`}>
        {label}
      </span>
    </div>
  )
}

export default function PasswordComplexityRules({ complexity, className = '' }) {
  const current = complexity || {}

  return (
    <div className={`space-y-3 rounded-lg bg-surface-container-low p-4 ${className}`}>
      <p className="text-[10px] font-black uppercase tracking-[0.16em] text-outline">
        Complexity Standards
      </p>
      <RuleItem met={Boolean(current.minLength)} label="Minimum 12 characters" />
      <RuleItem met={Boolean(current.hasSpecialAndNumber)} label="Include special character & number" />
      <RuleItem met={Boolean(current.noSequential)} label="Avoid sequential patterns" />
    </div>
  )
}
